<div class="form-group">
    <label class="input-label">Description:</label>
    <input type="text"
           name="fieldOptions.label"
           value="{{fieldOptions.description}}"
           [(ngModel)]="fieldOptions.description"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>